(function(){
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // --- Header scroll state ---
  const initHeaderScroll = () => {
    const header = document.getElementById('site-header');
    if (!header) return;
    const onScroll = () => { if (window.scrollY > 40) header.classList.add('is-scrolled'); else header.classList.remove('is-scrolled'); };
    window.addEventListener('scroll', onScroll, {passive:true});
    onScroll();
  };

  // --- Sticky CTA visibility (when hero scrolls out of view) ---
  const initStickyCta = () => {
    const hero = document.getElementById('hero');
    const stickyCta = document.getElementById('stickyCta');
    if (!('IntersectionObserver' in window) || !hero || !stickyCta) return;
    const heroObs = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) stickyCta.classList.remove('is-visible'); else stickyCta.classList.add('is-visible'); });
    }, {threshold: 0.1});
    heroObs.observe(hero);
  };

  // --- Mobile menu open/close ---
  const initMobileMenu = () => {
    const navMenu = document.getElementById('nav-menu');
    const mobileMenu = document.getElementById('mobile-menu');
    const mobileClose = document.getElementById('mobile-close');
    if (!navMenu || !mobileMenu) return;
    const openMenu = () => { mobileMenu.classList.add('is-open'); mobileMenu.setAttribute('aria-hidden','false'); navMenu.setAttribute('aria-expanded','true'); document.body.classList.add('is-locked'); };
    const closeMenu = () => { mobileMenu.classList.remove('is-open'); mobileMenu.setAttribute('aria-hidden','true'); navMenu.setAttribute('aria-expanded','false'); document.body.classList.remove('is-locked'); };
    if (!navMenu.dataset.bound) { navMenu.addEventListener('click', openMenu); navMenu.dataset.bound = '1'; }
    if (mobileClose && !mobileClose.dataset.bound) { mobileClose.addEventListener('click', closeMenu); mobileClose.dataset.bound = '1'; }
    mobileMenu.querySelectorAll('a').forEach(a => { if (!a.dataset.bound) { a.addEventListener('click', closeMenu); a.dataset.bound = '1'; } });
    if (!document.body.dataset.escBound) {
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) closeMenu(); });
      document.body.dataset.escBound = '1';
    }
  };

  // --- FAQ accordion (scope: section or document) ---
  const initFaq = (scope) => {
    (scope || document).querySelectorAll('[data-qa]').forEach(item => {
      if (item.dataset.bound) return;
      item.dataset.bound = '1';
      const row = item.querySelector('.qa__row');
      if (!row) return;
      row.setAttribute('role','button');
      row.setAttribute('tabindex','0');
      row.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
      const toggle = () => { item.classList.toggle('is-open'); row.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false'); };
      row.addEventListener('click', toggle);
      row.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
    });
  };

  // --- Scroll-triggered reveals (scope: section or document) ---
  // In the Shopify theme editor, sections re-render on edit; just mark them visible immediately.
  const inEditor = typeof Shopify !== 'undefined' && Shopify.designMode;
  const initReveals = (scope) => {
    const els = (scope || document).querySelectorAll('.reveal');
    if (inEditor || reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(el => el.classList.add('in'));
      return;
    }
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e,i) => {
        if (e.isIntersecting) {
          setTimeout(() => e.target.classList.add('in'), i * 60);
          obs.unobserve(e.target);
        }
      });
    }, {rootMargin: '0px 0px -8% 0px', threshold: 0.12});
    els.forEach(el => { if (!el.classList.contains('in')) obs.observe(el); });
  };

  // --- Before/after carousel (scope: section or document) ---
  const initCarousel = (scope) => {
    const root = scope || document;
    const carousel = root.querySelector('#ba-carousel') || (root.id === 'ba-carousel' ? root : null);
    if (!carousel) return;
    const track = carousel.querySelector('#ba-track');
    const prevBtn = carousel.querySelector('#ba-prev');
    const nextBtn = carousel.querySelector('#ba-next');
    const dotsEl = carousel.querySelector('#ba-dots');
    const currentEl = carousel.querySelector('#ba-current');
    const totalEl = carousel.querySelector('#ba-total');
    if (!track || !prevBtn || !nextBtn || !dotsEl) return;
    const slides = Array.from(track.children);
    const total = slides.length;
    if (total === 0) return;
    let index = 0;
    const getVisible = () => { const w = window.innerWidth; if (w <= 520) return 1; if (w <= 1024) return 2; return 3; };
    let visible = getVisible();
    let pages = Math.ceil(total / visible);
    if (totalEl) totalEl.textContent = String(total).padStart(2,'0');
    const updateDots = (p) => {
      dotsEl.innerHTML = '';
      for (let i = 0; i < p; i++) {
        const dot = document.createElement('button');
        dot.className = 'carousel__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Page ' + (i + 1));
        dot.addEventListener('click', () => { index = i * visible; if (index > total - visible) index = total - visible; render(); });
        dotsEl.appendChild(dot);
      }
    };
    const render = () => {
      const firstSlide = track.querySelector('.carousel__slide');
      if (!firstSlide) return;
      const slideWidth = firstSlide.getBoundingClientRect().width;
      const gap = parseInt(getComputedStyle(track).gap) || 0;
      track.style.transform = `translateX(${-index * (slideWidth + gap)}px)`;
      slides.forEach(s => s.classList.remove('is-center'));
      if (visible >= 3) { const centerIdx = index + 1; if (slides[centerIdx]) slides[centerIdx].classList.add('is-center'); }
      const currentPage = Math.min(Math.round(index / visible), pages - 1);
      dotsEl.querySelectorAll('.carousel__dot').forEach((d, i) => { d.classList.toggle('is-active', i === currentPage); });
      if (currentEl) currentEl.textContent = String(Math.min(index + 1, total)).padStart(2,'0');
      prevBtn.disabled = index === 0;
      nextBtn.disabled = index >= total - visible;
    };
    // Bind once
    if (!prevBtn.dataset.bound) { prevBtn.addEventListener('click', () => { index = Math.max(0, index - visible); render(); }); prevBtn.dataset.bound = '1'; }
    if (!nextBtn.dataset.bound) { nextBtn.addEventListener('click', () => { index = Math.min(total - visible, index + visible); render(); }); nextBtn.dataset.bound = '1'; }
    updateDots(pages); render();
    let resizeT; window.addEventListener('resize', () => {
      clearTimeout(resizeT);
      resizeT = setTimeout(() => {
        visible = getVisible(); pages = Math.ceil(total / visible);
        if (index > total - visible) index = Math.max(0, total - visible);
        updateDots(pages); render();
      }, 120);
    });
  };

  // --- Before/after drag slider (pointer events: mouse + touch + pen) ---
  const initBaSlider = (scope) => {
    (scope || document).querySelectorAll('[data-ba-slider]').forEach(slider => {
      if (slider.dataset.bound) return;
      slider.dataset.bound = '1';
      const afterImg = slider.querySelector('.ba-slider__img--after');
      const handle = slider.querySelector('.ba-slider__handle');
      const beforeTag = slider.querySelector('.ba-slider__tag--before');
      const afterTag = slider.querySelector('.ba-slider__tag--after');
      if (!afterImg || !handle) return;

      let currentPct = 50;
      const setPct = (pct) => {
        currentPct = Math.max(0, Math.min(100, pct));
        afterImg.style.clipPath = `inset(0 0 0 ${currentPct}%)`;
        afterImg.style.webkitClipPath = `inset(0 0 0 ${currentPct}%)`;
        handle.style.left = `${currentPct}%`;
        slider.setAttribute('aria-valuenow', Math.round(currentPct));
        // Fade labels: before-label shows as you reveal the before image (left side);
        // after-label shows when after image is visible (right side).
        // Both visible at 50%, each fades to 0 at its respective extreme.
        if (beforeTag) beforeTag.style.opacity = Math.max(0, Math.min(1, (currentPct - 5) / 30));
        if (afterTag)  afterTag.style.opacity  = Math.max(0, Math.min(1, (95 - currentPct) / 30));
      };

      const pctFromEvent = (e) => {
        const rect = slider.getBoundingClientRect();
        return ((e.clientX - rect.left) / rect.width) * 100;
      };

      slider.addEventListener('pointerdown', (e) => {
        e.preventDefault();
        slider.setPointerCapture(e.pointerId);
        setPct(pctFromEvent(e));
      });
      slider.addEventListener('pointermove', (e) => {
        if (slider.hasPointerCapture(e.pointerId)) {
          setPct(pctFromEvent(e));
        }
      });
      const releasePointer = (e) => {
        if (slider.hasPointerCapture(e.pointerId)) {
          slider.releasePointerCapture(e.pointerId);
        }
      };
      slider.addEventListener('pointerup', releasePointer);
      slider.addEventListener('pointercancel', releasePointer);

      // Keyboard support (left/right arrows, home/end)
      slider.addEventListener('keydown', (e) => {
        let next = currentPct;
        if (e.key === 'ArrowLeft') next -= 5;
        else if (e.key === 'ArrowRight') next += 5;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = 100;
        else return;
        e.preventDefault();
        setPct(next);
      });

      // Initialize at 50%
      setPct(50);
    });
  };

  // --- Run everything on initial load ---
  const initAll = (scope) => {
    initReveals(scope);
    initFaq(scope);
    initCarousel(scope);
    initBaSlider(scope);
    initMobileMenu();
  };
  initHeaderScroll();
  initStickyCta();
  initAll(document);

  // --- Shopify theme editor re-renders sections on edit; re-init what's inside ---
  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
  document.addEventListener('shopify:section:select', (event) => {
    // When a section is clicked in the editor, make sure its reveals are visible
    event.target.querySelectorAll('.reveal').forEach(el => el.classList.add('in'));
  });
  document.addEventListener('shopify:block:select', (event) => {
    // When a block is clicked, ensure its parent section is visible
    let el = event.target;
    while (el && el !== document.body) {
      if (el.classList && el.classList.contains('reveal')) el.classList.add('in');
      el = el.parentElement;
    }
  });
})();
